<template>
  <ArticleEdit :articleid="articleid" />
</template>
<script>
export default {
  computed: {
    articleid() {
      return this.$route.params.id;
    },
  },
  };
</script>
